// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdfDisplayDiv {
    background-color: white;
    width: 70%;
    min-height: 84vh;
    margin: auto;
    margin-top: 2%;
    margin-bottom: 5%;
    padding-left: 2%;
    /* padding-right: -4% !important; */
    padding-top: 0% !important;
    padding-bottom: 0% !important;
    overflow: auto;
    max-height: 84vh;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 5px;
    height: 84vh;
}
.temp2MainDiv{
    /* background-color: aqua; */
    min-height: 84vh;
    width: 100%;

}
.tep2LeftCol{
    /* background-color: yellow; */
    padding-top: 5%;
    min-height: 84vh;
    padding-left: 5%;

}
.tep2RightCol{
    background-color: #082d4d;
    min-height: 84vh;
    padding-top: 23%;
    color: white;
    position: relative;
    right: -2.8%;
}
.temp2CLeftContent{
    margin-top: 8%;
}
.temp2DisplayImage{
    width: 45px;
    position: absolute;
    top: 0% !important;
    left: -8px;
}
.profileName {
    padding: 0;
    margin: 0;
    padding-left: 4%;
    position: relative;
    font-weight: 520;
    color: rgb(30, 37, 50);
    color: rgb(22, 89, 143);
    font-size: 10px;
}
.temp2NameDiv {
    margin: 0;
    padding: 0;
    display: inline-block;
    width: 80%;
    /* background-color: #5ec57e; */
    margin-left: 5% !important;
}
.temp2GreyFont{
    margin-top: 8% !important;
    color: rgb(130, 139, 162);
}
.temp2PersonalDetails{
    font-size: 10px !important;
}

/* Media query for mobile view */
@media screen and (max-width: 890px) {
    .tep2LeftCol {
        width: 66%; /* Full width for both columns */
        padding-top: 5%; /* Adjust padding for better spacing */
        padding-left: 5%;
    }

    .tep2RightCol {
        width: 33%; /* Full width for both columns */
        padding-top: 5%; /* Adjust padding for better spacing */
        right: -6.8%;
    }

    .pdfDisplayDiv {
        width: 95% !important; /* Full width for PDF display */
    }
}
`, "",{"version":3,"sources":["webpack://./src/styleSheet/temp2.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mCAAmC;IACnC,0BAA0B;IAC1B,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;;AAEf;AACA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;;AAEpB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,UAAU;IACV,+BAA+B;IAC/B,0BAA0B;AAC9B;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,0BAA0B;AAC9B;;AAEA,gCAAgC;AAChC;IACI;QACI,UAAU,EAAE,gCAAgC;QAC5C,eAAe,EAAE,sCAAsC;QACvD,gBAAgB;IACpB;;IAEA;QACI,UAAU,EAAE,gCAAgC;QAC5C,eAAe,EAAE,sCAAsC;QACvD,YAAY;IAChB;;IAEA;QACI,qBAAqB,EAAE,+BAA+B;IAC1D;AACJ","sourcesContent":[".pdfDisplayDiv {\n    background-color: white;\n    width: 70%;\n    min-height: 84vh;\n    margin: auto;\n    margin-top: 2%;\n    margin-bottom: 5%;\n    padding-left: 2%;\n    /* padding-right: -4% !important; */\n    padding-top: 0% !important;\n    padding-bottom: 0% !important;\n    overflow: auto;\n    max-height: 84vh;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    border-radius: 5px;\n    height: 84vh;\n}\n.temp2MainDiv{\n    /* background-color: aqua; */\n    min-height: 84vh;\n    width: 100%;\n\n}\n.tep2LeftCol{\n    /* background-color: yellow; */\n    padding-top: 5%;\n    min-height: 84vh;\n    padding-left: 5%;\n\n}\n.tep2RightCol{\n    background-color: #082d4d;\n    min-height: 84vh;\n    padding-top: 23%;\n    color: white;\n    position: relative;\n    right: -2.8%;\n}\n.temp2CLeftContent{\n    margin-top: 8%;\n}\n.temp2DisplayImage{\n    width: 45px;\n    position: absolute;\n    top: 0% !important;\n    left: -8px;\n}\n.profileName {\n    padding: 0;\n    margin: 0;\n    padding-left: 4%;\n    position: relative;\n    font-weight: 520;\n    color: rgb(30, 37, 50);\n    color: rgb(22, 89, 143);\n    font-size: 10px;\n}\n.temp2NameDiv {\n    margin: 0;\n    padding: 0;\n    display: inline-block;\n    width: 80%;\n    /* background-color: #5ec57e; */\n    margin-left: 5% !important;\n}\n.temp2GreyFont{\n    margin-top: 8% !important;\n    color: rgb(130, 139, 162);\n}\n.temp2PersonalDetails{\n    font-size: 10px !important;\n}\n\n/* Media query for mobile view */\n@media screen and (max-width: 890px) {\n    .tep2LeftCol {\n        width: 66%; /* Full width for both columns */\n        padding-top: 5%; /* Adjust padding for better spacing */\n        padding-left: 5%;\n    }\n\n    .tep2RightCol {\n        width: 33%; /* Full width for both columns */\n        padding-top: 5%; /* Adjust padding for better spacing */\n        right: -6.8%;\n    }\n\n    .pdfDisplayDiv {\n        width: 95% !important; /* Full width for PDF display */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
